<h3 *ngIf="!isEditing" mat-dialog-title>Criando Processo Seletivo</h3>
<h3 *ngIf="isEditing" mat-dialog-title>Editando Processo Seletivo</h3>
<mat-dialog-content>
  <form [formGroup]="form">
    <!-- <div class="row" style="display: flex; width: 100%; margin-top: 10px">
      <div class="flex-dir">
        
      </div>

      <div class="flex-esq">
        
      </div>
    </div> -->

    <div class="row" style="display: flex; width: 100%; margin-top: 10px">
      <!-- Bloco esquerdo para Nome da Empresa -->
      <div class="flex-dir">
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Nome do processo</mat-label>
            <input type="text" matInput placeholder="Nome do processo seletivo" formControlName="name" id="name" />
            <mat-error *ngIf="form.get('name').errors?.required">
              Por favor informe o nome
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Número de Vagas</mat-label>
            <input
              matInput
              type="text"
              placeholder="Informe o número de vagas"
              autocomplete="off"
              formControlName="qtd"
              inputmode="numeric"
              pattern="[0-9]*"
              id="qtd"
              (keypress)="preventNonNumeric($event)"
            />
            <mat-error *ngIf="form.get('qtd').errors?.required">
              Por favor, informe o número de vagas
            </mat-error>
            <mat-error *ngIf="form.get('qtd').errors?.pattern">
              Apenas números são permitidos
            </mat-error>
            <mat-error *ngIf="form.get('qtd').errors?.max">
              O número de vagas não pode ser superior a 1000
            </mat-error>
            <mat-error *ngIf="form.get('qtd').errors?.min">
              O número mínimo de vagas é 1
            </mat-error>
            <mat-hint>O número máximo de vagas é 1000</mat-hint> 
          </mat-form-field>        
        </div>
        <mat-slide-toggle
          formControlName="viewname"
          style="margin-bottom: 10px; margin-top: 10px;"
        >
          Mostrar Nome da Empresa no Processo Seletivo?
        </mat-slide-toggle>
        <div *ngIf="form.get('viewname').value">
          <mat-form-field appearance="outline" style="width: 100%; margin-top: 10px">
            <mat-label>Nome fantasia da Empresa</mat-label>
            <input matInput placeholder="Nome fantasia da empresa" formControlName="companyname" id="companyname" />
            <mat-error *ngIf="form.get('companyname').errors?.required">
              Por favor informe o nome fantasia
            </mat-error>
          </mat-form-field>
        </div>
        <mat-slide-toggle
          formControlName="viewtel"
          style="margin-bottom: 10px; margin-top: 10px;"
        >
          Mostrar Telefone da Empresa no Processo Seletivo?
        </mat-slide-toggle>
        <div *ngIf="form.get('viewtel').value">
          <mat-form-field appearance="outline">
            <mat-label>Telefone</mat-label>
            <input
              matInput
              type="phone"
              placeholder="Informe o número de telefone"
              mask="(00) 00000 0000"
              formControlName="phone"
              inputmode="numeric"
            />
            <mat-error *ngIf="form.get('phone').errors?.required"
              >Por favor informe o telefone</mat-error
            >
          </mat-form-field>
        </div>
        <fieldset>
          <legend>Detalhes do Serviço</legend>
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Regime de contratação</mat-label>
              <mat-select placeholder="Selecione uma opção" formControlName="workregime" id="workregime">
                <mat-option value="CLT">CLT</mat-option>
                <mat-option value="PJ">PJ</mat-option>
                <mat-option value="Informal">Informal</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('workregime').errors?.invalid">Escolha uma das opções</mat-error>
              <mat-error *ngIf="form.get('workregime').errors?.required">Por favor selecione um regime</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Modelo de trabalho</mat-label>
              <mat-select placeholder="Selecione uma opção" formControlName="modalityjob" id="modalityjob">
                <mat-option value="Presencial">Presencial</mat-option>
                <mat-option value="Home Office">Home Office</mat-option>
                <mat-option value="Híbrido">Híbrido</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('modalityjob').errors?.invalid">Escolha uma das opções</mat-error>
              <mat-error *ngIf="form.get('modalityjob').errors?.required">Por favor selecione uma opção</mat-error>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Cargo</mat-label>
              <input type="text" id="sinonimo" (blur)="onBlurInput('sinonimo')" (focus)="onFocusInput('sinonimo')"
                placeholder="Cargo" (keyup)="_filterSinonimo($event.target.value)" matInput formControlName="sinonimo"
                [matAutocomplete]="autoSinonimo" />
              <mat-autocomplete #autoSinonimo="matAutocomplete">
                <mat-option *ngFor="let Sinonimo of filteredSinonimo" [value]="Sinonimo.Name">
                  {{ Sinonimo.Name }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="form.get('sinonimo').errors?.invalid">Escolha um dos valores que aparecem na lista ao
                digitar</mat-error>
              <mat-error *ngIf="form.get('sinonimo').errors?.required">Por favor informe o cargo</mat-error>
            </mat-form-field>
            <div style="display: flex; flex-direction: column; align-items: anchor-center;">
              <div class="checkbox-group-horizontal">
                <mat-radio-group formControlName="tipocargo" class="radio-group">
                  <mat-radio-button value="junior" id="cargo-junior">Júnior</mat-radio-button>
                  <mat-radio-button value="pleno" id="cargo-pleno">Pleno</mat-radio-button>
                  <mat-radio-button value="senior" id="cargo-senior">Sênior</mat-radio-button>
                </mat-radio-group> 
                <mat-icon class="reset" (click)="resetValue()">restart_alt</mat-icon>
              </div>

              <!-- mensagem de erro abaixo -->
              <small class="mat-error" *ngIf="form.get('tipocargo').errors?.invalid || form.get('tipocargo').errors?.required" style="margin-top: 4px; font-size: 10.5px;">
                Por favor selecione uma opção
              </small>
            </div>
          </div>
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Moeda</mat-label>
              <mat-select placeholder="Selecione uma opção" formControlName="coin" id="coin">
                <mat-option value="BRL">BRL (R$)</mat-option>
                <mat-option value="USD">USD ($)</mat-option>
                <mat-option value="EUR">EUR (€)</mat-option>
                <mat-option value="GBP">GBP (£)</mat-option>
                <mat-option value="JPY">JPY (¥)</mat-option>
                <mat-option value="AUD">AUD (A$)</mat-option>
                <mat-option value="CAD">CAD (C$)</mat-option>
                <mat-option value="CHF">CHF (CHF)</mat-option>
                <mat-option value="CNY">CNY (¥)</mat-option>
                <mat-option value="SEK">SEK (kr)</mat-option>
                <mat-option value="NZD">NZD (NZ$)</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('coin').errors?.invalid">Escolha uma das opções</mat-error>
              <mat-error *ngIf="form.get('coin').errors?.required">Por favor selecione um opção</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Salário</mat-label>
              <!-- <input
                matInput
                type="text"
                placeholder="Informe o valor"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
                inputmode="numeric"
                formControlName="salary"
              /> -->
              <input matInput type="text" placeholder="Informe um valor ou 0 para (à combinar)" [formControl]="form.get('salary')"
                (input)="formatMoneyInput($event)" id="salary" />
              <mat-error *ngIf="form.get('salary').errors?.required">Por favor informe o salário</mat-error>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Dias</mat-label>
              <mat-select formControlName="daysWeek" multiple id="daysWeek">
                <mat-option value="monday">Segunda-feira</mat-option>
                <mat-option value="tuesday">Terça-feira</mat-option>
                <mat-option value="wednesday">Quarta-feira</mat-option>
                <mat-option value="thursday">Quinta-feira</mat-option>
                <mat-option value="friday">Sexta-feira</mat-option>
                <mat-option value="saturday">Sábado</mat-option>
                <mat-option value="sunday">Domingo</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Início da Jornada de Trabalho</mat-label>
              <input type="time" matInput placeholder="Horário de trabalho inicio" formControlName="start_monday"
                [value]="formatarHora(form.get('start_monday')?.value)" id="start_monday" style="margin: 0 0 -10px;"/>
              <mat-error *ngIf="form.get('start_monday').errors?.required">
                Por favor informe o inicio da jornada
              </mat-error>
            </mat-form-field>
            <p class="until">até</p>
            <mat-form-field appearance="outline">
              <mat-label>Fim da Jornada de Trabalho</mat-label>
              <input type="time" matInput placeholder="Horário de trabalho fim" formControlName="end_monday"
                [value]="formatarHora(form.get('end_monday')?.value)" id="end_monday" style="margin: 0 0 -10px;"/>
              <mat-error *ngIf="form.get('end_monday').errors?.required">
                Por favor informe o fim da jornada
              </mat-error>
            </mat-form-field>
          </div>

          <!-- <ng-container *ngFor="let dia of form.get('daysWeek')?.value">
            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label
                  >Início da Jornada de Trabalho ({{
                    getDiaSemana(dia)
                  }})</mat-label
                >
                <input
                  type="time"
                  matInput
                  placeholder="Horário de trabalho inicio"
                  [formControlName]="'start_' + dia"
                  [value]="formatarHora(form.get('start_' + dia)?.value)"
                />
              </mat-form-field>
              <p class="until">até</p>
              <mat-form-field appearance="outline">
                <mat-label
                  >Fim da Jornada de Trabalho ({{
                    getDiaSemana(dia)
                  }})</mat-label
                >
                <input
                  type="time"
                  matInput
                  placeholder="Horário de trabalho fim"
                  [formControlName]="'end_' + dia"
                  [value]="formatarHora(form.get('end_' + dia)?.value)"
                />
              </mat-form-field>
            </div>
          </ng-container> -->
        </fieldset>
        <mat-slide-toggle formControlName="viewend" style="margin-bottom: 10px">
          Endereço específico da vaga (diferente do cadastrado)?
        </mat-slide-toggle>
        <div *ngIf="form.get('viewend').value">
          <fieldset>
            <legend>Localização</legend>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>CEP</mat-label>
                <input matInput type="text" placeholder="Informe seu cep" autocomplete="off" formControlName="zipCode"
                  mask="00000-000" inputmode="numeric" id="zipCode" />
                <mat-error *ngIf="form.get('zipCode').errors?.required">Por favor informe o CEP</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Estado</mat-label>
                <mat-autocomplete #autoState="matAutocomplete" [displayWith]="displayState"
                  (optionSelected)="onStateSelected($event)">
                  <ng-container *ngFor="let state of filteredStates$ | async">
                    <mat-option [value]="state">{{ state.nome }}</mat-option>
                  </ng-container>
                </mat-autocomplete>
                <input matInput type="text" placeholder="Informe o estado" autocomplete="off" formControlName="state"
                  [matAutocomplete]="autoState" id="state" />
                <mat-error *ngIf="form.get('state').errors?.required">Por favor informe o estado</mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Cidade</mat-label>
                <mat-autocomplete #autoCity="matAutocomplete">
                  <ng-container *ngFor="let city of filteredCities$ | async">
                    <mat-option [value]="city.name">{{ city.name }}</mat-option>
                  </ng-container>
                </mat-autocomplete>
                <input matInput type="text" placeholder="Informe a cidade" autocomplete="off" formControlName="city"
                  [matAutocomplete]="autoCity" id="city" />
                <mat-hint>Escolha o estado para mostrar as cidades</mat-hint>
                <mat-error *ngIf="form.get('city').errors?.required">Por favor informe a cidade</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Bairro</mat-label>
                <input matInput type="text" placeholder="Informe seu bairro" autocomplete="off"
                  formControlName="district" id="district" />
                <mat-error *ngIf="form.get('district').errors?.required">Por favor informe o bairro</mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Rua/avenida</mat-label>
                <input matInput type="text" placeholder="Informe a rua/avenida" autocomplete="off"
                  formControlName="street" id="street" />
                <mat-error *ngIf="form.get('street').errors?.required">Por favor informe a rua</mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Número</mat-label>
                <input matInput type="text" placeholder="Informe o número" autocomplete="off" formControlName="number"
                  inputmode="numeric" id="number" />
                <mat-error *ngIf="form.get('number').errors?.required">Por favor informe o número</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Complemento</mat-label>
                <input matInput type="text" placeholder="Informe o complemento" autocomplete="off"
                  formControlName="complement" />
              </mat-form-field>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="flex-esq">
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Descrição da Vaga</mat-label>
            <textarea
              matInput
              placeholder="informe a Descrição da vaga"
              formControlName="description"
              rows="7"
              maxlength="2000"
              id="description"
            ></textarea>
            <button
              *ngIf = "useIA"
              matSuffix
              color="primary"
              mat-icon-button
              type="button"
              (click)="generateAI('description')"
              [disabled]="submiting"
              matTooltip="Gerar descrição usando IA"
            >
              <mat-icon>smart_toy</mat-icon>
            </button>
            <mat-hint>Informe até 1000 caracteres</mat-hint>
            <mat-error *ngIf="form.get('description').errors?.required"
              >Por favor preencher o campo</mat-error
            >
            <mat-error *ngIf="form.get('description').errors?.maxlength"
              >Por favor informe no máximo 1000 caracteres</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" style="margin-top: 10px">
          <mat-form-field appearance="outline">
            <mat-label>Requisitos</mat-label>
            <textarea
              matInput
              placeholder="informe os requisitos para vaga"
              formControlName="requirements"
              rows="7"
              maxlength="1100"
              id="requirements"
            ></textarea>
            <mat-hint>Informe até 1000 caracteres</mat-hint>
            <mat-error *ngIf="form.get('requirements').errors?.required"
              >Por favor preencher o campo</mat-error
            >
            <mat-error *ngIf="form.get('requirements').errors?.maxlength"
              >Por favor informe no máximo 1000 caracteres</mat-error
            >
            <button
                *ngIf = "useIA"
                matSuffix
                color="primary"
                mat-icon-button
                type="button"
                (click)="generateAI('requirements')"
                [disabled]="submiting"
                matTooltip="Gerar requisitos usando nossa IA"
              >
                <mat-icon>smart_toy</mat-icon>
              </button>
          </mat-form-field>
        </div>
    
        <div class="row" style="margin-top: 10px">
          <mat-form-field appearance="outline">
            <mat-label>Atividades a serem desempenhadas</mat-label>
            <textarea
              matInput
              placeholder="descreva as atividades a serem desempenhadas"
              formControlName="activities"
              rows="7"
              maxlength="1100"
              id="activities"
            ></textarea>
            <mat-hint>Informe até 1000 caracteres</mat-hint>
            <mat-error *ngIf="form.get('activities').errors?.required"
              >Por favor preencher o campo</mat-error
            >
            <mat-error *ngIf="form.get('activities').errors?.maxlength"
              >Por favor informe no máximo 1000 caracteres</mat-error
            >
            <button
                *ngIf = "useIA"
                matSuffix
                color="primary"
                mat-icon-button
                type="button"
                (click)="generateAI('activities')"
                [disabled]="submiting"
                matTooltip="Gerar atividades usando nossa IA"
              >
                <mat-icon>smart_toy</mat-icon>
              </button>
          </mat-form-field>
        </div>
        
        <div class="row" style="margin-top: 10px">
          <mat-form-field appearance="outline">
            <mat-label>Lista de benefícios</mat-label>
            <textarea matInput placeholder="Descreva os beneficios dessa vaga Ex: VT VR VA" formControlName="benefits" rows="7"
              maxlength="1100" id="benefits"></textarea>
            <mat-hint>Informe até 1000 caracteres</mat-hint>
            <mat-error *ngIf="form.get('benefits').errors?.required">Por favor preencher o campo</mat-error>
            <mat-error *ngIf="form.get('benefits').errors?.maxlength">Por favor informe no máximo 1000
              caracteres</mat-error>
              <button
                *ngIf = "useIA"
                matSuffix
                color="primary"
                mat-icon-button
                type="button"
                (click)="generateAI('benefits')"
                [disabled]="submiting"
                matTooltip="Gerar benefícios usando nossa IA"
              >
                <mat-icon>smart_toy</mat-icon>
              </button>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button color="accent" mat-dialog-close mat-button>Cancelar</button>

  <button *ngIf="isEditing" color="primary" mat-raised-button (click)="updateProcess()">
    Salvar Alterações
  </button>

  <button *ngIf="!isEditing" color="primary" mat-raised-button (click)="submit()">
    Iniciar processo seletivo
  </button>
</mat-dialog-actions>